<template>
	<div>
		<TilteParallax>
			<template v-slot:title>
				Listas de precio
			</template>
			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="default"
							fab
							v-bind="attrs"
							v-on="on"
							elevation="5"
						>
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item @click="pricelistsCreate()">
							<v-list-item-title>
								Nuevo
							</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>

			<template v-slot:subtitle>
				{{ `${pricelists.length} listas de precio.` }}
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center" class="pt-0 mt-0">
				<v-col cols="12" md="10">
					<v-card outlined :loading="ui.geting">
						<v-card-text>
							<v-row>
								<v-col cols="12" class="pb-0">
									<v-text-field
										dense
										outlined
										clearable
										hide-details
										label="Cíterio de busqueda"
										v-model="criterium"
									></v-text-field>
								</v-col>

								<v-col cols="12">
									<v-data-table
										:search="criterium"
										:headers="headers"
										:items="pricelists"
									>
										<!-- Slot Customers -->
										<template
											v-slot:item.customers="{ item }"
										>
											{{
												item.customers
													? item.customers.length
													: 0
											}}
										</template>

										<!-- Slot Actions -->
										<template
											v-slot:item.actions="{ item }"
										>
											<router-link
												class="font-weight-bold"
												:to="{
													name: 'PriceListShow',
													params: { id: item.id },
												}"
											>
												Ver
											</router-link>
										</template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- PricelistsCreate Component -->
		<PricelistsCreate></PricelistsCreate>
	</div>
</template>

<script>
import axios from "axios";
import { EventBus } from "@/main";
import TilteParallax from "@/components/TilteParallax";
import { mapState } from "vuex";
import PricelistsCreate from "@/components/PriceList/Create";

export default {
	name: "Index",

	components: { TilteParallax, PricelistsCreate },

	data() {
		return {
			headers: [
				{ text: "Id", value: "id" },
				{ text: "Nombre", value: "name" },
				{ text: "Artículos vinculados", value: "articles_count" },
				{ text: "Clientes vinculados", value: "customers_count" },
				{ text: "Ultima actualización", value: "updated_at_new" },
				{ text: "Acciones", value: "actions" },
			],

			criterium: null,

			pricelists: [],

			ui: {
				geting: true,
			},
		};
	},

	created() {
		this.get();

		EventBus.$on("PriceListCreated", (pricelist) => {
			this.pricelists.push(pricelist);
		});
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;
				let response = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/pricelist`,
					{
						headers: {
							Authorization: `Bearer ${this.acount.token}`,
						},
					}
				);

				this.pricelists = response.data.data;
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		pricelistsCreate() {
			EventBus.$emit("PriceListCreate");
		},
	},

	computed: {
		...mapState(["acount"]),
	},
};
</script>

<style lang="css" scoped></style>
